import { render, staticRenderFns } from "./CheckPayment.vue?vue&type=template&id=dd785654&"
import script from "./CheckPayment.vue?vue&type=script&lang=js&"
export * from "./CheckPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports